export const campaignFormScroll = function() {
	const jump = jumper();
	const formLink = document.querySelector('.jsScrollTo');
	if (!formLink) return;
	formLink.addEventListener('click', _=> {
		const scrollToEl = document.querySelector('.diagnostic-form');
		if (!scrollToEl) return;
		jump(scrollToEl);
	});
}
